import { filterTime } from '@/api/filter';
export const config = {
  data() {
    return {
      columns: [],
      columns1: [
        {
          title: '推荐人',
          align: 'center',
          minWidth: 130,
          slot: 'userName_staffNo'
        },
        {
          title: '所属团队',
          align: 'center',
          key: 'groupName',
          minWidth: 200
        },
        {
          title: '所属机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '关联保单件数',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '基础费用',
          renderHeader: (h, params) => {
            return (
              <div>
                <span>基础费用</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                  <div slot="content">
                    <p>该活动中业务员所出保单产生的基础费用累计</p>
                  </div>
                </Poptip>
              </div>
            );
          },
          align: 'center',
          key: 'baseFirstIncome',
          minWidth: 100
        },
        {
          title: '增员奖励',
          align: 'center',
          key: 'activityIncome',
          minWidth: 100
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 100,
          fixed: 'right'
        }
      ],
      columns2: [
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '推荐人人数',
          align: 'center',
          key: 'userNum',
          minWidth: 200
        },
        {
          title: '关联保单件数',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '基础费用',
          renderHeader: (h, params) => {
            return (
              <div>
                <span>基础费用</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                  <div slot="content">
                    <p>该活动中业务员所出保单产生的基础费用累计</p>
                  </div>
                </Poptip>
              </div>
            );
          },
          align: 'center',
          key: 'baseFirstIncome',
          minWidth: 100
        },
        {
          title: '增员奖励',
          align: 'center',
          key: 'activityIncome',
          minWidth: 100
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 100,
          fixed: 'right'
        }
      ]
    };
  },
  methods:{
    setColumns() {
      let value = this.tabVal;
      let columns = [];
      if (this.reportType == '4-2' || this.reportType == '4-1') {
        if (value == 1) {
          columns = [
            {
              title: '业务员',
              align: 'center',
              minWidth: 130,
              slot: 'userName_staffNo'
            },
            {
              title: '件数',
              align: 'center',
              key: 'policyNum',
              minWidth: 120
            },
            {
              title: '保单数',
              align: 'center',
              key: 'policyNum',
              minWidth: 120
            },
            {
              title: '批单数',
              align: 'center',
              key: 'billNum',
              minWidth: 120
            },
            {
              title: '保费',
              align: 'center',
              key: 'fee',
              minWidth: 120
            },
            {
              title: '标保',
              align: 'center',
              key: 'foldFyb',
              minWidth: 200
            },
            {
              title: '基础费用',
              renderHeader: (h, params) => {
                return (
                  <div>
                    <span>基础费用</span>
                    <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                      <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                      <div slot="content">
                        <p>该活动中业务员所出保单产生的基础费用累计</p>
                      </div>
                    </Poptip>
                  </div>
                );
              },
              align: 'center',
              key: 'baseFirstIncome',
              minWidth: 100
            },
            {
              title: '奖励',
              align: 'center',
              key: 'activityIncome',
              minWidth: 100
            },
            {
              title: '团队',
              align: 'center',
              key: 'groupName',
              minWidth: 100
            },
            {
              title: '机构',
              align: 'center',
              key: 'orgName',
              minWidth: 100
            },
            {
              title: '操作',
              slot: 'action',
              align: 'center',
              width: 100,
              fixed: 'right'
            }
          ];
        } else {
          columns = [
            {
              title: '机构',
              align: 'center',
              key: 'orgName',
              minWidth: 100
            },
            {
              title: '人数',
              align: 'center',
              key: 'userNum',
              minWidth: 130
            },
            {
              title: '件数',
              align: 'center',
              key: 'policyNum',
              minWidth: 120
            },
            {
              title: '保单数',
              align: 'center',
              key: 'policyNum',
              minWidth: 120
            },
            {
              title: '批单数',
              align: 'center',
              key: 'billNum',
              minWidth: 120
            },
            {
              title: '保费',
              align: 'center',
              key: 'fee',
              minWidth: 120
            },
            {
              title: '奖励',
              align: 'center',
              key: 'activityIncome',
              minWidth: 100
            },
            {
              title: '操作',
              slot: 'action',
              align: 'center',
              width: 100,
              fixed: 'right'
            }
          ];
        }
      } else if (this.reportType == '2-2') {
        if (value == 1) {
          columns = [
            {
              title: '推荐人',
              align: 'center',
              minWidth: 250,
              slot: 'recommendname_staffNo'
            },
            {
              title: '推荐人所属团队',
              align: 'center',
              key: 'groupName',
              minWidth: 100
            },
            {
              title: '推荐人所属机构',
              align: 'center',
              key: 'orgName',
              minWidth: 150
            },
            {
              title: '增员人数',
              align: 'center',
              key: 'beRecommendedNum',
              minWidth: 100
            },
            {
              title: '增员奖励',
              align: 'center',
              key: 'activityIncome',
              minWidth: 100
            },
            {
              title: '操作',
              slot: 'action',
              align: 'center',
              width: 100,
              fixed: 'right'
            }
          ];
        } else {
          this.salesmanId = null;
          columns = [
            {
              title: '机构',
              align: 'center',
              key: 'orgName',
              minWidth: 150
            },
            {
              title: '推荐人人数',
              align: 'center',
              key: 'userNum',
              minWidth: 150
            },
            {
              title: '增员人数',
              align: 'center',
              key: 'beRecommendedNum',
              minWidth: 150
            },
            {
              title: '增员奖励',
              align: 'center',
              key: 'activityIncome',
              minWidth: 100
            },
            {
              title: '操作',
              slot: 'action',
              align: 'center',
              width: 100,
              fixed: 'right'
            }
          ];
        }
      } else if (this.reportType == '5-2') {
        // 签约活动
        if (value == 1) {
          columns = [
            {
              title: '签约人',
              align: 'center',
              minWidth: 250,
              slot: 'userName_staffNo'
            },
            {
              title: '所属团队',
              align: 'center',
              key: 'groupName',
              minWidth: 100
            },
            {
              title: '所属机构',
              align: 'center',
              key: 'orgName',
              minWidth: 150
            },
            {
              title: '签约日期',
              align: 'center',
              key: 'entryTime',
              width: 150,
              render(h, params) {
                let text = params.row.entryTime;
                return <span>{text ? text.substr(0, 10) : '-'}</span>;
              }
            },
            {
              title: '签约奖励',
              align: 'center',
              key: 'activityIncome',
              minWidth: 100
            },
          ];
        } else {
          this.salesmanId = null;
          columns = [
            {
              title: '机构',
              align: 'center',
              key: 'orgName',
              minWidth: 150
            },
            {
              title: '签约人数',
              align: 'center',
              key: 'userNum',
              minWidth: 150
            },
            {
              title: '签约奖励',
              align: 'center',
              key: 'activityIncome',
              minWidth: 100
            },
          ];
        }
      } else {
        if (value == 1) {
          columns = this.columns1;
        } else {
          salesmanId = null;
          columns = this.columns2;
        }
        if (this.statisticsObj.billNum && columns.find(i => i.key == 'policyNum')) {
          let idx = columns.findIndex(i => i.key == 'policyNum');
          columns.splice(idx+1, 0, {
            title: '关联批单件数',
            align: 'center',
            key: 'billNum',
            minWidth: 100
          });
        }
      }
      this.columns = columns;
    },
  }
};
